export default __webpack_public_path__ + "static/media/pdc_print_cover.b1945aba.jpg";